import { Component } from 'react';
import lodash from 'lodash';

import Toggle from 'components/common/Toggle/Toggle';
import { Button, BUTTON } from 'components/common/Button/Button';
const { COLOR } = BUTTON;

import styles from './ExpandedValidation.scss';

import { getValidationStatus } from './BinderValidation';
import DocumentRow from './DocumentRow';




export default class ExpandedValidation extends Component {

    toggleValidationRequirement(e) {
        this.props.setDocumentValidationRequirement(e.target.checked);
    }

    render() {
        const { 
            documentValidation,
            onDocumentClick,
            onClose,
            onfile,
            openFilePicker,
            uploadedDocuments
        } = this.props;
        
        const { expectedNumOfCopies, actualNumOfCopies } = documentValidation;

        const validationStatus = getValidationStatus(documentValidation);
        const documentTypeClass = documentValidation.isValid ? styles.filed : styles.missing;
        
        const activeUploads = lodash.get(uploadedDocuments, `${documentValidation.id}`, {});
        const unfiledActiveUploads = lodash.chain(activeUploads)
            .toArray()
            .differenceBy(documentValidation.matchingDocuments, 'id')
            .value();

        if(!documentValidation.isRequired) {
            return (
                <div className={styles.ExpandedValidation} data-cy="ExpandedValidation">
                    <div className={styles.body}>
                        <div className={styles.header}>
                            <div>
                                <span className={styles.notRequired} data-cy="ExpandedValidation-documentTypeName">{documentValidation.documentTypeName}</span>
                                <span className={styles.validationNotRequiredPill}>NOT REQUIRED</span>
                            </div>
                            <i className={styles.ExpandedValidation__close} aria-label="Close" onClick={onClose} data-cy="ExpandedValidation-onClose"></i>
                        </div>

                        <div className={styles.actionButtons}>
                            <Button
                                text={'Close'}
                                color={COLOR.RED}
                                onClick={onClose} 
                                data-cy="ExpandedValidation-Close"/>
                            <div className={styles.validationRequiredToggle} data-cy="ExpandedValidation-Toggle">
                                <span>Required:</span>
                                <Toggle onToggle={this.toggleValidationRequirement.bind(this)} isChecked={documentValidation.isRequired} />
                            </div>
                        </div>
                    </div>
                </div>
            );
        }

        return (
            <div className={styles.ExpandedValidation} data-cy="ExpandedValidation-return">
                <div className={styles.body}>
                    <div className={styles.header}>
                        <div>
                            <span className={documentTypeClass} data-cy="ExpandedValidation-copies">{documentValidation.documentTypeName} - {actualNumOfCopies}/{expectedNumOfCopies}</span>
                            <span className={`${validationStatus.style} ${styles.validationStatusPill}`} data-cy="ExpandedValidation-message">{validationStatus.message}</span>
                        </div>
                        <i className={styles.ExpandedValidation__close} aria-label="Close" onClick={onClose} data-cy="ExpandedValidation-onCloses"></i>
                    </div>
                    <div className={validationStatus.labelStyle} data-cy="ExpandedValidation-label">
                        {validationStatus.label}
                    </div>
                    <span className={styles.subHeader} data-cy="ExpandedValidation-actualNumOfCopies">{actualNumOfCopies > 0 && 'Copies'}</span>
                    <div className={styles.documents} data-cy="ExpandedValidation-documents">
                        {lodash.map(documentValidation.matchingDocuments, (doc, index) => <DocumentRow type={'filed'} document={doc} onfile={onfile} expand={actualNumOfCopies === 1} index={index} onDocumentClick={onDocumentClick} />)}
                        {lodash.map(unfiledActiveUploads, (doc)=> <DocumentRow type={'unfiled'} document={doc} onfile={onfile} documentTypeId={documentValidation.documentTypeId} onDocumentClick={onDocumentClick} />)}
                        <DocumentRow type={'none'} openFilePicker={openFilePicker} />
                    </div>
                    <div className={styles.actionButtons}>
                        <Button
                            text={'Close'}
                            color={COLOR.RED}
                            onClick={onClose} 
                            data-cy="ExpandedValidation-Closes"/>
                        <div className={styles.validationRequiredToggle} data-cy="ExpandedValidation-Required">
                            <span>Required:</span>
                            <Toggle data-cy="ExpandedValidation-onToggle" onToggle={this.toggleValidationRequirement.bind(this)} isChecked={documentValidation.isRequired} />
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}
